if (!customElements.get('wishlist-count')) {
  class WishlistCount extends HTMLElement {
    constructor() {
      super();

      this.updateCountUnsubscribe = undefined;
      this.syncCountUnsubscribe = undefined;
    }

    connectedCallback() {
      requirejs(['pubsub'], () => {
        this.syncCountUnsubscribe = subscribeEvent(
          PUB_SUB_EVENTS.wishlistSync,
          ({ source, data }) => {
            this.updateWishlistCount();
          }
        );
  
        this.updateCountUnsubscribe = subscribeEvent(
          PUB_SUB_EVENTS.wishlistUpdate,
          ({ source, data }) => {
            this.updateWishlistCount();
          }
        );
      })
    }

    disconnectedCallback() {
      if (this.updateCountUnsubscribe) this.updateCountUnsubscribe();
      if (this.syncCountUnsubscribe) this.syncCountUnsubscribe();
    }

    updateWishlistCount() {
      const wishlistText = localStorage.getItem('wishlist');

      if (!wishlistText || wishlistText == '') this.textContent = 0;
      else {
        const wishlistArr = wishlistText.split('||');
        let wishlistCount = 0;

        wishlistArr.forEach((wishlist) => {
          if (wishlist != '' && wishlist.trim() != '') wishlistCount++;
        });

        this.textContent = wishlistCount;
      }
    }
  }

  customElements.define('wishlist-count', WishlistCount);
}
